module.exports = __webpack_public_path__ + "img/68.fa1a944a.jpg";